import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { AlertType, RetAPI, bgLineGridColorDark, bgLineGridColorLight, ContaAReceber, corBgGrid } from '../../Utils/Types'
import { Button, createTheme, ThemeProvider } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import moment from 'moment'
import { IoEye } from 'react-icons/io5'
import { Funcoes } from '../../Utils/Funcoes'
import { useNavigate } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'
import { RiEdit2Fill } from 'react-icons/ri'
import { FaTrashAlt } from 'react-icons/fa'
import { ModalAuditoriaDuplicatas } from '../ModalAuditoriaDuplicatas/modal_auditoria_duplicatas'
import { ContaAReceberService } from '../../Pages/ContasAReceber/ContaAReceberService'

type Props = {
    duplicata: ContaAReceber[],
    handleUpdateDuplicataList: () => void,
    handleSelectItemClick: (id: number, selected: boolean, taxa: number) => void,
    handleColumnLiqClick: () => void,
    tipo: TipoStatus,
    id_select: boolean,
    selectedAll: boolean,
}

type VisibilityState = Record<string, boolean>

export type TipoStatus = | "A" | "L"

interface RowData {
    id: number,
    data_vencimento: string,
    dt_baixa: string,
    dt_cadastro: string,
    dt_last_update: string,
    id_cliente: number,
    id_user_baixa: string,
    id_user_insert: string,
    id_user_last_update: string,
    id_venda: number,
    id_bordero: number,
    nome_user_last_update: string,
    nome_user_baixa: string,
    nome_user_insert: string,
    nome_cliente: string,
    obs_baixa: string
    observacao: number,
    serie: number,
    qtdDup: number,
    valor: number,
    valor_original: number,
    vl_desconto: string,
    vl_juros: number,
    selected: boolean,
    taxa_juros: number,
    valorJuros: number,
    nome: string
}

export const GridContaAReceber = React.memo(({ duplicata, handleUpdateDuplicataList, handleSelectItemClick, handleColumnLiqClick, tipo, id_select, selectedAll }: Props) => {

    /*
    const xJson = localStorage.getItem("@commerce/column_grid_ctareceber")

    let json: any = {
        estornar: false,
        liquidar: true,
        auditoria: false,
        acao: true,
        id: true,
        dt_cadastro: true,
        data_vencimento: true,
        observacao: true,
        observacao_baixa: false,
        serie: true,
        valor: true,
        valor_original: true,

        //vl_desconto: true,
        //vl_juros: true,
    }


    if (xJson) {
        json = JSON.parse(localStorage.getItem("@commerce/column_grid_ctareceber") || '')
    }
    */

    /*
        useEffect(() => {
    
            if (xJson) {
    
                if (json) {
                    const newColumnVisibility: VisibilityState = { ...columnVisibility }
                    newColumnVisibility.id = json.id
                    newColumnVisibility.dt_cadastro = json.dt_cadastro
                    newColumnVisibility.data_vencimento = json.data_vencimento
                    newColumnVisibility.serie = json.serie
                    newColumnVisibility.valor = json.valor
                    newColumnVisibility.valor_original = json.valor_original
                }
            }
    
        }, [])
    */

    /*
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10, // personaliza o tamanho padrão da página  
    })
    */

    const defaultJson = useMemo(() => {
        return (

            localStorage.getItem("@commerce/column_grid_ctareceber")
                ? JSON.parse(localStorage.getItem("@commerce/column_grid_ctareceber") || '')
                : {
                    estornar: false,
                    liquidar: true,
                    auditoria: false,
                    acao: true,
                    id: true,
                    nome_cliente: true,
                    dt_cadastro: true,
                    data_vencimento: true,
                    observacao: true,
                    nome: false,
                    observacao_baixa: false,
                    serie: true,
                    valor: true,
                    valor_original: true,
                    taxa_juros: true,
                    valorJuros: true,
                    dt_baixa: false
                }
        )
    }, [])

    const [idExcluir, setIdExcluir] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [state, setState] = useState(false)
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(defaultJson)

    const [userCriador, setUserCriador] = useState("")
    const [dtCriador, setDtCriador] = useState("")
    const [usertAtt, setUsertAtt] = useState("")
    const [dtAtt, setDtAtt] = useState("")
    const [userBaixa, setUserBaixa] = useState("")
    const [dtBaixa, setDtBaixa] = useState("")

    const [visibleModalAuditoria, setVisibleModalAuditoria] = useState(false)
    const [duplicatas, setDuplicatas] = useState<ContaAReceber[]>([])
    const [nomeDuplicatasReceber, setNomeDuplicatasReceber] = useState("")

    let user = useSelector(state => selectUser(state))


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EFFECT -------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        setDuplicatas([])

        const timer = setTimeout(() => {
            const newColumnVisibility = { ...columnVisibility }

            // Sempre atualiza essas colunas com base no tipo
            newColumnVisibility.acao = tipo === "A"
            newColumnVisibility.observacao = tipo === "A"
            newColumnVisibility.id = tipo === "A"
            newColumnVisibility.dt_cadastro = tipo === "A"
            newColumnVisibility.data_vencimento = tipo === "A"
            newColumnVisibility.serie = tipo === "A"
            //newColumnVisibility.valor = tipo === "A"
            newColumnVisibility.valor_original = tipo === "A"
            newColumnVisibility.nome_cliente = tipo === "A"
            newColumnVisibility.taxa_juros = tipo === "A"
            newColumnVisibility.valorJuros = tipo === "A"

            newColumnVisibility.qtdDup = tipo === "L"
            newColumnVisibility.id_bordero = tipo === "L"
            newColumnVisibility.observacao_baixa = tipo === "L"
            newColumnVisibility.nome = tipo === "L"
            newColumnVisibility.estornar = tipo === "L"

            //newColumnVisibility.auditoria = tipo === "L"

            // Só define essas se houver id_select
            if (id_select) {
                newColumnVisibility.liquidar = tipo === "A"
                
            } else {
                newColumnVisibility.liquidar = false
            }

            setColumnVisibility(newColumnVisibility)
            clearTimeout(timer)
        }, 150)

        return () => clearTimeout(timer)

    }, [tipo, id_select])

    useEffect(() => {
        setDuplicatas(duplicata)
    }, [duplicata])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_ctareceber", JSON.stringify(columnVisibility))
    }, [columnVisibility])

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EXCLUIR e FOCUS ----------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setFeedBackVisible(false)
        setIsLoading(true)

        try {

            const retApi: RetAPI = await ContaAReceberService.Delete(idExcluir, motivo, senha)

            if (!retApi.error) {
                setFeedBackVisible(true)
                setAlertType("SUCCESS")
                setMessageFeedBack(`Duplicata excluída com sucesso`)

                handleUpdateDuplicataList()
                //setModalShow(false)

            } else {
                setFeedBackVisible(true)
                setAlertType("DANGER")
                setMessageFeedBack(retApi.msg || ``)
                setIsLoading(false)
            }

        } catch (error) {
            setIsLoading(false)
            setFeedBackVisible(true)
            setAlertType("DANGER")
            setMessageFeedBack(`Não foi possível excluir a duplicata. Por favor, tente novamente`)

        }

    }, [idExcluir])

    const fecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)

        if (alertType == 'SUCCESS') {
            setModalShow(false)
            setNomeDuplicatasReceber("")
        }
    }, [alertType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        setModalShow(false)
        setNomeDuplicatasReceber("")
    }, [])

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- NAVEGAÇÃO ----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaDupReceberEdit = (id: number) => {
        navigate(`/contaAreceber/edit/${id}`)
    }


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TEMAS --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const theme = createTheme({
        palette: {
            mode: user.modeDark,
            background: {
                default: user.modeDark === 'light' ? '#fff' : '#475569',
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- COLUNAS ------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleCheckBoxClick = (id: number, selected: boolean, taxa: number) => {

        /*
        const novaSelecao = !selected;

        // Se está desmarcando, verificar se nenhum outro ainda está marcado
        if (!novaSelecao) {
            const aindaSelecionados = duplicata.filter(d => d.selected && d.id !== id);
            if (aindaSelecionados.length === 0) {
                setFiltroTaxaSelecionada(null); // Libera todos os checkboxes
            }
        } else {
            const novaTaxa = taxa > 0 ? 'com_juros' : 'sem_juros';
            setFiltroTaxaSelecionada(novaTaxa);
        }
        */

        setState(!state)
        handleSelectItemClick(id, selected, taxa)
    }

    const calcularTaxa = (rowData: RowData): number => {
        const hoje = new Date();
        const dias = parseInt(localStorage.getItem("@ecommerce/diasJuros") || '0')

        // Cria a data de vencimento
        const vencimentoBase = new Date(rowData.data_vencimento);

        // Soma os dias
        const vencimento = new Date(vencimentoBase);
        vencimento.setDate(vencimento.getDate() + 1 + dias);

        const taxa = (rowData.data_vencimento && vencimento < hoje)
            ? parseFloat(localStorage.getItem("@ecommerce/taxa_juros") || '0')
            : 0;

        return taxa;
    }

    const abrirModalAuditoria = () => {
        setVisibleModalAuditoria(true)
    }

    const fecharModalAuditoria = useCallback(() => {
        setVisibleModalAuditoria(false)
    }, [])

    let colunasArray: MRT_ColumnDef<ContaAReceber>[] = []

    const columns = useMemo<MRT_ColumnDef<ContaAReceber>[]>(() => [

        /* --------------------------------------------------------------------------------------------------------------------------------------------------------- */
        {
            accessorKey: 'estornar',
            header: '[Estornar]',
            size: 150,
            visibleInShowHideMenu: tipo === 'L' ? true : false,
            muiTableBodyCellProps: { align: 'center' },
            muiTableHeadCellProps: { align: 'center' },
            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                let taxa = calcularTaxa(rowData)

                return (

                    <div className={`w-full h-[30px]`} >

                        <input
                            id={'checkbox-' + rowData.id}
                            aria-label={rowData.id.toString()}
                            type='checkbox'
                            onChange={() => handleCheckBoxClick(rowData.id, rowData.selected, taxa)}
                            checked={!!rowData.selected}
                            className={`h-5 w-5 mx-2 cursor-pointer`}
                        />

                        <Tooltip
                            style={{ backgroundColor: 'rgb(30, 41, 59)', zIndex: 9999 }}
                            id={'tooltip-checkbox-' + rowData.id}
                            anchorSelect={'#checkbox-' + rowData.id}
                            positionStrategy='fixed' >
                            <span >
                                Selecione para <br />
                                estornar
                            </span>
                        </Tooltip>

                    </div>
                )
            }
        },

        {
            accessorKey: 'liquidar',
            Header: (props) => {
                return <input type='checkbox' className={`accent-blue-500 h-5 w-5 outline-none cursor-pointer`} checked={selectedAll} onChange={handleColumnLiqClick} />
            },
            header: '',
            size: 120,
            visibleInShowHideMenu: tipo === 'A' ? true : false,
            muiTableBodyCellProps: { align: 'center' },
            muiTableHeadCellProps: { align: 'center' },
            Cell: ((cell: any) => {

                const rowData = cell.row.original as RowData

                let taxa = calcularTaxa(rowData)

                /*
                disabled={
                        filtroTaxaSelecionada === 'com_juros' && taxa === 0 ||
                        filtroTaxaSelecionada === 'sem_juros' && taxa > 0
                    }
                */

                return (
                    <div className={`w-full h-[30px]`}>

                        <input
                            id={'checkbox-' + rowData.id}
                            aria-label={rowData.id.toString()}
                            type='checkbox'
                            onChange={() => handleCheckBoxClick(rowData.id, rowData.selected, taxa)}
                            className={`accent-blue-500 h-5 w-5 outline-none cursor-pointer`}
                            checked={!!rowData.selected}
                        />

                        <Tooltip
                            style={{ backgroundColor: 'rgb(30, 41, 59)' }}
                            id={'tooltip-checkbox-' + rowData.id}
                            anchorSelect={'#checkbox-' + rowData.id}
                            positionStrategy='fixed' >
                            <span>
                                Selecione para <br />
                                liquidação
                            </span>
                        </Tooltip>
                    </div>

                )
            }
            )
        },

        {
            accessorKey: 'auditoria',
            header: 'Auditoria',
            size: 100,
            visibleInShowHideMenu: false, //tipo === 'L' ? true : false,
            muiTableBodyCellProps: { align: 'center' },
            muiTableHeadCellProps: { align: 'center' },
            Cell: ((cell: any) => {

                const rowData = cell.row.original as RowData
                const handleAuditoriaClick = () => {

                    setUserCriador(rowData.nome_user_insert || '')
                    setUsertAtt(rowData.nome_user_last_update || '')
                    setUserBaixa(rowData.nome_user_baixa || '')
                    setDtCriador(moment(rowData.dt_cadastro).format('DD/MM/YYYY') || '')
                    setDtAtt(moment(rowData.dt_last_update).format('DD/MM/YYYY') || '')
                    setDtBaixa(moment(rowData.dt_baixa).format('DD/MM/YYYY') || '')

                    abrirModalAuditoria()
                }

                return (
                    <div className={`flex items-center justify-center bg-slate-500 dark:bg-slate-400 hover:bg-slate-600 dark:hover:bg-slate-700 w-full h-[30px] rounded-md`}>

                        <Button data-tooltip-id={'tooltip-editar-' + rowData.id} id={'link-' + rowData.id} className={`flex items-center justify-center text-white transition-all duration-300`} onClick={handleAuditoriaClick} >

                            <IoEye className={`text-slate-200 dark:text-white`} size="18px" />

                            <Tooltip style={{ backgroundColor: 'rgb(148, 163, 184)' }} id={'tooltip-editar-' + rowData.id} anchorSelect={'#link-' + rowData.id} positionStrategy="fixed" >
                                <span>Auditoria</span>
                            </Tooltip>

                        </Button>

                    </div>

                )
            })
        },

        {
            accessorKey: 'acao',
            header: 'Ações',
            size: 100,
            visibleInShowHideMenu: tipo === 'A' ? true : false,
            muiTableBodyCellProps: { align: 'left' },
            muiTableHeadCellProps: { align: 'left' },
            Cell: ((cell: any) => {

                const rowData = cell.row.original as RowData

                const navegar = () => {
                    navegarTelaDupReceberEdit(rowData.id)
                }

                const handleExcluirClick = () => {

                    const timerExcluir = setTimeout(() => {
                        setIdExcluir(rowData.id)
                        setNomeDuplicatasReceber(rowData.id.toString())
                        setModalShow(true)

                        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement

                        if (divPerfil) {
                            divPerfil.classList.add('hidden')
                        }

                        let menuFiltro = document.getElementById("divMenuFiltroDupRec") as HTMLDivElement
                        let menuInputs = document.getElementById("divInputsDupRec") as HTMLDivElement
                        let bodySearchCliente = document.getElementById("bodySearchBox-cliente") as HTMLDivElement

                        if (menuFiltro) {

                            bodySearchCliente.classList.remove("visible")

                            menuInputs.classList.add("invisible")

                            const timer = setTimeout(() => {
                                menuFiltro.classList.remove("max-h-[1000px]")
                                menuFiltro.classList.add("max-h-[0px]")
                                clearTimeout(timer)
                            }, 100)
                        }

                        clearTimeout(timerExcluir)
                    }, 0)

                }

                return (
                    <div className={`flex items-center w-full h-[30px]`}>

                        <button
                            onClick={navegar} data-tooltip-id={'tooltip-editar-' + rowData.id} id={'link-' + rowData.id}
                            className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                          bg-sky-500`} >
                            <RiEdit2Fill size="20px" />

                            <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-' + rowData.id} anchorSelect={'#link-' + rowData.id} positionStrategy="fixed" >
                                <span>Editar</span>
                            </Tooltip>

                        </button>

                        <button
                            onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-' + rowData.id} id={'btn-excluir-' + rowData.id}
                            className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                          bg-red-500 ml-2`}>
                            <FaTrashAlt size="18px" />

                            <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-' + rowData.id} anchorSelect={'#btn-excluir-' + rowData.id} positionStrategy="fixed" place='top-end'>
                                <span>Excluir</span>
                            </Tooltip>

                        </button>


                    </div>

                )
            }

            )
        },

        /* --------------------------------------------------------------------------------------------------------------------------------------------------------- */
        {
            accessorKey: 'id', visibleInShowHideMenu: tipo === 'A' ? true : false /*true*/, header: 'Duplicata', size: 150, muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.id ? rowData.id : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'nome_cliente', visibleInShowHideMenu: tipo === 'A' ? true : false /*true*/, header: 'Cliente', size: 150, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.nome_cliente ? rowData.nome_cliente : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'dt_cadastro', visibleInShowHideMenu: tipo === 'A' ? true : false /*true*/, header: 'Data de Emissão', size: 150, muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.dt_cadastro ? moment(rowData.dt_cadastro).format('DD/MM/YYYY') : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'data_vencimento',
            header: 'Data de Vencimento', visibleInShowHideMenu: tipo === 'A' ? true : false /*true*/, size: 150, muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.data_vencimento ? moment(rowData.data_vencimento).format('DD/MM/YYYY') : <span className='text-red-400'>N/D</span>}</span>)


            }
        },

        {
            accessorKey: 'dt_baixa',
            header: 'Data da Baixa', visibleInShowHideMenu: false /*tipo === 'L' ? true : false*/, size: 150, muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.dt_baixa ? moment(rowData.dt_baixa).format('DD/MM/YYYY') : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'serie', visibleInShowHideMenu: tipo === 'A' ? true : false /*true*/, header: 'Série', size: 50, muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.serie ? rowData.serie : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'nome', visibleInShowHideMenu: tipo === 'L' ? true : false, header: 'Cliente', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.nome ? rowData.nome : <span className='text-red-400'>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'observacao_baixa', visibleInShowHideMenu: tipo === 'L' ? true : false, header: 'Observação da Baixa', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.obs_baixa ? rowData.obs_baixa : <span className='text-red-400'>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'qtdDup', visibleInShowHideMenu: tipo === 'L' ? true : false /*true*/, header: 'Qtd duplicatas', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.qtdDup ? rowData.qtdDup : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'valor_original', visibleInShowHideMenu: tipo === 'L' ? true : false /*true*/, header: 'valor Original', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.valor_original ? Funcoes.numberFormat(rowData.valor_original, 'currency') : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'valor', visibleInShowHideMenu: true, header: 'Valor', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.valor ? Funcoes.numberFormat(rowData.valor, 'currency') : <span className='text-red-400'>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'taxa_juros', visibleInShowHideMenu: tipo === 'A' ? true : false /*true*/, header: 'Juros(%) ao Mês', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {
                const rowData = cell.row.original as RowData;

                let taxa = calcularTaxa(rowData)

                return (
                    <span>
                        {taxa + "%"}
                    </span>
                );
            }
        },

        {
            accessorKey: 'valorJuros', visibleInShowHideMenu: tipo === 'A' ? true : false, header: 'Valor Com Juros', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {
                const rowData = cell.row.original as RowData;
                const valor = Number(rowData.valor ?? 0);
                const hoje = new Date();
                let valorComJuros = valor;

                if (rowData.data_vencimento && valor > 0) {
                    const taxaPadrao = parseFloat(localStorage.getItem("@ecommerce/taxa_juros") || '0')
                    const dias = Number(localStorage.getItem("@ecommerce/diasJuros") || 0)

                    // Soma dias à data de vencimento
                    const vencimentoBase = new Date(rowData.data_vencimento);
                    const vencimento = new Date(vencimentoBase);
                    vencimento.setDate(vencimento.getDate() + 1 + dias);

                    // Normaliza as horas para evitar problema de fuso
                    const hojeZero = new Date(hoje);
                    hojeZero.setHours(0, 0, 0, 0);
                    const vencZero = new Date(vencimento);
                    vencZero.setHours(0, 0, 0, 0);

                    const diffTime = hojeZero.getTime() - vencZero.getTime();
                    const diffDias = Math.max(Math.floor(diffTime / (1000 * 60 * 60 * 24)), 0);

                    if (diffDias > 0) {

                        const taxaPercent = taxaPadrao          // ex.: 5 = 5% ao mês
                        const taxaDiaria = (taxaPercent / 100) / 30;    // proporcional ao mês
                        const juros = valor * taxaDiaria * diffDias;    // juros simples
                        valorComJuros = valor + juros;
                    }
                }

                return (
                    <span>
                        {valor
                            ? Funcoes.numberFormat(valorComJuros, 'currency')
                            : <span className='text-red-400'>N/D</span>}
                    </span>
                );
            }
        },

        {
            accessorKey: 'id_bordero', visibleInShowHideMenu: tipo === 'L' ? true : false /*true*/, header: 'Bordero', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.id_bordero ? rowData.id_bordero : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'observacao', visibleInShowHideMenu: tipo === 'A' ? true : false, header: 'Observação', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.observacao ? rowData.observacao : <span className='text-red-400'>N/D</span>}</span>)
            }
        },

    ], [duplicata]
    )

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TABLE --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const table = useMaterialReactTable({
        paginationDisplayMode: 'pages',
        columns: columns,
        data: duplicatas,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,
        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        localization: MRT_Localization_PT_BR,
        enableEditing: false,
        enableTopToolbar: false,
        enableColumnActions: false,
        enableColumnFilters: false,
        enableHiding: false,
        enableFilters: false,
        enableMultiSort: false,
        enableSorting: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
        initialState: {
            pagination: { pageIndex: 0, pageSize: 10 },  // Define 10 elementos por página
        },
        muiPaginationProps: {
            rowsPerPageOptions: [10],  // Apenas uma opção para o seletor: 10
        },

    })

    return (
        <>

            <ThemeProvider theme={theme}>
                <MaterialReactTable table={table} />
            </ThemeProvider>

            <ModalExcluirDados
                show={modalShow}
                isLoading={isLoading}
                message={`Deseja excluir a duplicata - ${nomeDuplicatasReceber || ''}?`}
                alertType={alertType}
                feedBackVisible={feedBackVisible}
                messageFeedBack={messageFeedBack}
                closeModalEvent={fecharModalExcluirDados}
                excluirEvent={handleExcluir}
                fecharModalEvent={buttonFecharModalExcluirDados}
            />

            <ModalAuditoriaDuplicatas
                visible={visibleModalAuditoria}
                dt_cadastro={dtCriador || ''}
                name_user_insert={userCriador || ''}
                dt_last_updat={dtAtt || ''}
                name_user_last_update={usertAtt || ''}
                dt_baixa={dtBaixa || ''}
                name_user_baixa={userBaixa || ''}
                closeModalEvent={fecharModalAuditoria}
            />

        </>
    )

})